import { render, staticRenderFns } from "./singleAdministrationChildrenSecondEdit.vue?vue&type=template&id=027e7152"
import script from "./singleAdministrationChildrenSecondEdit.vue?vue&type=script&lang=js"
export * from "./singleAdministrationChildrenSecondEdit.vue?vue&type=script&lang=js"
import style0 from "./singleAdministrationChildrenSecondEdit.vue?vue&type=style&index=0&id=027e7152&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports